import { Button, Modal, Table } from "antd";
import React, { useState, useCallback, useEffect } from "react";
import { CustomCol, CustomRow } from "../../components/Custom";
import DetailTitle from "../../components/DetailTitle";
import ModalScrollContainer from "../../components/ModalScrollContainer";
import { fetchTransferRecordLogGet } from "../../services/transferRecordLog";
import { findDict, formatTime, moneyAddComma } from "../../utils";
const TransferRecordDetail = (props) => {
    const [ visible, setVisible ] = useState(false) // 当前组件显示状态
    const [ detailData, setDetailData ] = useState({}) // 当前组件数据
    const [ transferRecordLogId, setTransferRecordLogId ] = useState(null); // 当前组件的ID
    const [ counterofferInfoList, setCounterofferInfoList ] = useState(null) // 回盘文件汇总数据 明细
   
    const open = (transferRecordLogId) => {
        setVisible(true)
        setTransferRecordLogId(transferRecordLogId)
    }
    const close = () => {
        setVisible(false)
        setTransferRecordLogId(null)
    }
    const renderFooter = () => <Button onClick={close}>关闭</Button>
    const postTransRecordGet = (data) => {
        fetchTransferRecordLogGet(data).then(res => {
            setDetailData(res || {})
        })
    }
    const mapTransferRecordStatus = [
        { title: '待审核', value: 1 },
        { title: '审核中', value: 2 },
        { title: '审核未通过', value: 3 },
        { title: '待支付', value: 4 },
        { title: '处理中', value: 5 },
        { title: '划付成功', value: 6 },
        { title: '划付失败', value: 7 },
        { title: '划分文件上传失败', value: 8 },
        { title: '部分分账成功', value: 9 },
    ]

    const mapTransferRecordInfoStatus = [
        { title: '失败', value: 0 },
        { title: '成功', value: 1 },
        { title: '部分成功', value: 2 },
        { title: '处理中', value: 3 },
        { title: '未提交', value: 4 },
    ]

    const mapTransferRecordType = [
        { title: '云贷费用', value: 1 },
        { title: '业主租金', value: 2 },
        { title: '平台运营费用', value: 3 },
        { title: '商户结余退款', value: 4 },
        { title: '其他费用', value: 5 },
        { title: '电子认证费用', value: 7 },
        { title: '物业运营服务费', value: 8 },
        { title: '代付业主租金', value: 9 },

    ]

    const mapNewsTransferRecordType = [
        { title: '代付平台云贷费用', value: 2 },
        { title: '平台服务费用', value: 3 },
        { title: '银联手续费', value: 4 },
        { title: '其他费用', value: 5 },
        { title: '电子认证费用', value: 7 },
        { title: '物业运营服务费', value: 8 },
        { title: '代付业主租金', value: 9 },

    ]

    const mapInstructionType = [
        { title: '银联分账', value: 1 },
        { title: '银联划付', value: 2 },
    ]
    
    const infoColumns = [
        { title: '收款单位', dataIndex: 'accountName', width: 200 },
        { title: '收款账号', dataIndex: 'accountNumber', width: 120},
        { title: '开户行', dataIndex: 'bankName', width: 120 },
        { title: '开户行行号', dataIndex: 'bankNo', width: 120 },
        { title: '银联商户号', dataIndex: 'merchantNo', width: 120 },
        { title: '清算金额', dataIndex: 'transferAmount' , render:(text) => {
                return text ? moneyAddComma(text / 100) : text
            }, width: 80},
        { title: '清算状态', dataIndex: 'transferRecordStatus', render:(text) => {
                return findDict(mapTransferRecordInfoStatus, text).title
            } , width: 70},
        { title: '指令业务处理费', dataIndex: 'orderServiceProcessingFee', width: 120, render:(text) => {
                return text ? moneyAddComma(text / 100) : '0'
            } },
        { title: '指令结算金额', dataIndex: 'orderSettlementAmount', render:(text) => {
                return text ? moneyAddComma(text / 100) : '0'
            }, width: 120 },
        { title: '清算指令Id', dataIndex: 'deductionInstructionId', width: 200 },
        { title: '清算失败原因说明', dataIndex: 'transferRecordStatusMessage', width: 200 },
    ]

    const infoColumnsType1 = [
        { title: '银联商户号', dataIndex: 'merchantNo', width: 120 },
        { title: '清算金额', dataIndex: 'transferAmount' , render:(text) => {
                return text ? moneyAddComma(text / 100) : text
            }, width: 80},
        { title: '清算状态', dataIndex: 'transferRecordStatus', render:(text) => {
                return findDict(mapTransferRecordInfoStatus, text).title
            } , width: 70},
        { title: '指令业务处理费', dataIndex: 'orderServiceProcessingFee', width: 120, render:(text) => {
                return text ? moneyAddComma(text / 100) : '0'
            } },
        { title: '指令结算金额', dataIndex: 'orderSettlementAmount', render:(text) => {
                return text ? moneyAddComma(text / 100) : '0'
            }, width: 120 },
        { title: '清算指令Id', dataIndex: 'deductionInstructionId', width: 200 },
        { title: '清算失败原因说明', dataIndex: 'transferRecordStatusMessage', width: 200 },

    ]

    const counterofferColumns = [
        { title: '商户集团编号', dataIndex: 'merchantGroupNumber', width: 100 },
        { title: '成功笔数', dataIndex: 'successTransferNum', width: 80,  },
        { title: '成功金额', dataIndex: 'successTransferAmount', width: 80, render: (text) => {
                return text ? moneyAddComma(text / 100) : text
            } },
        { title: '手续费金额', dataIndex: 'handlingFeeAmount', width: 80, render: (text) => {
                return text ? moneyAddComma(text / 100) : text
            } },
        { title: '失败笔数', dataIndex: 'failTransferNum', width: 80 },
        { title: '失败金额', dataIndex: 'transferFailAmount', width: 80,render: (text) => {
                return text ? moneyAddComma(text / 100) : text
            } },
        { title: '部分成功笔数', dataIndex: 'partSuccessTransferNum', width: 120,render: (text) => {
                return text ? moneyAddComma(text / 100) : text
            }  },
        { title: '部分成功金额', dataIndex: 'partSuccessTransferAmount', width: 120, render: (text) => {
                return text ? moneyAddComma(text / 100) : text
            } },


        { title: '部分失败金额', dataIndex: 'partTransferFailAmount', width: 80 },
        { title: '处理中金额', dataIndex: 'processingAmount', width: 80 },
        { title: '处理中笔数', dataIndex: 'processingNum', width: 80 },
        { title: '成功金额与部分成功金额总和', dataIndex: 'realitySuccessTransferAmount', width: 200, render: (text) => {
            return text ? moneyAddComma(text / 100) : text
        } },
        { title: '回盘文件名称', dataIndex: 'fileName', width: 200, render: (text, records) => {
                return  <a href={records.fileUrl} target={'_blank'} style={{marginLeft: 5}}>{text}</a>
            }  },
        {title: '明细数据', dataIndex: 'actions',width: 80, fixed: 'right', render: (text, records) => {
            return <a onClick={() => setCounterofferInfoList(records.infoListVo)}>查看</a>
        }}
    ]

    const counterofferInfoColumns = [
        { title: '银联商户号', dataIndex: 'merchantNo',width: 120 },
        { title: '清算状态', dataIndex: 'transferRecordStatus', width: 80 ,render: (text) => {
            return findDict(mapTransferRecordInfoStatus, text).title
        } },
        { title: '成功金额', dataIndex: 'successTransferAmount',width: 120, render: (text) => {
                return text ? moneyAddComma(text / 100) : text
            } },
        { title: '清算金额', dataIndex: 'transferAmount',width: 120, render: (text) => {
            return text ? moneyAddComma(text / 100) : text
        } },
        { title: '指令结算金额', dataIndex: 'orderSettlementAmount',width: 120,  render: (text) => {
            return text ? moneyAddComma(text / 100) : text
        } },
        { title: '指令业务处理费', dataIndex: 'orderServiceProcessingFee',width: 120, render: (text) => {
            return text ? moneyAddComma(text / 100) : text
        } },
        { title: '在银商系统内唯一', dataIndex: 'insideBankId',width: 120 },
        { title: '清算指令Id', dataIndex: 'deductionInstructionId',width: 120,},
        { title: '退票预判', dataIndex: 'predeterminationCode',width: 100  },
        { title: '对预判码的解释', dataIndex: 'predeterminationCodeDesc',width: 200  },
        { title: '失败原因说明', dataIndex: 'transferRecordStatusMessage',width: 200  },
        { title: '创建时间', dataIndex: 'createTime',width: 120, render: (text) => formatTime(text, 'YYYY-MM-DD') },
    ]

    const refundFileColumns = [
        { title: '收款单位', dataIndex: 'accountName', width: 200 },
        { title: '收款账号', dataIndex: 'accountNumber', width: 200 },
        { title: '退票日期', dataIndex: 'refundDate', width: 200, render: (text) => {
                return formatTime(text, 'YYYY-MM-DD')
            } },
        { title: '开户行', dataIndex: 'bankName', width: 200 },
        { title: '开户行行号', dataIndex: 'bankNo', width: 200 },
        { title: '退票文件名称', dataIndex: 'fileName', width: 300, render: (text, records) => {
            return  <a href={records.fileUrl} target={'_blank'} style={{marginLeft: 5}}>{text}</a>
        } },
        { title: '商户集团编号', dataIndex: 'merchantGroupNumber', width: 200 },
        { title: '商户名称', dataIndex: 'merchantName', width: 200 },
        { title: '企业用户号', dataIndex: 'merchantNo', width: 200 },
        { title: '订单日期', dataIndex: 'orderDate', width: 200, render: (text) => {
            return formatTime(text, 'YYYY-MM-DD')
        } },
        { title: '订单号', dataIndex: 'orderNo', width: 200 },
        { title: '支付预判码', dataIndex: 'predeterminationCode', width: 200 },
        { title: '退票金额（元）', dataIndex: 'refundMoney', width: 200 },
        { title: '退票原因', dataIndex: 'refundReason', width: 200 },
        { title: '退票类型', dataIndex: 'refundType', width: 200 },
        { title: '划扣指令Id', dataIndex: 'deductionInstructionId', width: 200 },
        { title: '创建时间', dataIndex: 'createTime', width: 200, render: formatTime },
    ]



    useEffect(() => {
        transferRecordLogId && postTransRecordGet({ transferRecordLogId })
    },[transferRecordLogId])
    useCallback(() => {
        props.getRef && props.getRef({open})
    },[])()
    return <Modal width={950} title="清算记录详情" visible={visible} onCancel={close} footer={renderFooter()}>
        <ModalScrollContainer>
            <div className="custom" >
                <DetailTitle title="基础信息" />
                <CustomRow >
                    <CustomCol label="清算笔数">
                        <span style={{ paddingLeft:6 }}>{detailData.transferNum}</span>
                    </CustomCol>
                    <CustomCol label="费用类型">
                        <span style={{ paddingLeft:6 }}>{detailData.recordDetailsId>0?findDict(mapNewsTransferRecordType, detailData.transferRecordType).title:findDict(mapTransferRecordType, detailData.transferRecordType).title}</span>
                    </CustomCol>
                    <CustomCol label="清算状态">
                        <span style={{ paddingLeft:6 }}>{findDict(mapTransferRecordStatus, detailData.transferRecordStatus).title}</span>
                    </CustomCol>
                </CustomRow>
                <CustomRow divider>
                    <CustomCol label="商户集团号">
                        <span style={{ paddingLeft:6 }}>{detailData.merchantGroupNumber}</span>
                    </CustomCol>
                    <CustomCol label="总金额">
                        <span style={{ paddingLeft:6 }}>{moneyAddComma(detailData.totalAmount / 100)}</span>
                    </CustomCol>
                    <CustomCol label="指令上传时间">
                        <span style={{ paddingLeft:6 }}>{formatTime(detailData.uploadTime)}</span>
                    </CustomCol>
                </CustomRow>
                <CustomRow divider>
                    <CustomCol label="指令类型">
                        <span style={{ paddingLeft:6 }}>{findDict(mapInstructionType,detailData.instructionType).title}</span>
                    </CustomCol>
                    <CustomCol label="创建时间">
                        <span style={{ paddingLeft:6 }}>{formatTime(detailData.createTime)}</span>
                    </CustomCol>
                    
                </CustomRow>
                <DetailTitle title="指令文件" />
                <CustomRow>
                    <CustomCol label="文件名称" colStyle={{width: 802}}>
                        { detailData.fileUrl?<a style={{marginLeft: 6}} href={detailData.fileUrl} download><span style={{ paddingLeft:6 }}>{detailData.fileName}</span></a>:null}
                    </CustomCol>
                </CustomRow>
            
            
                <DetailTitle title="指令签名文件"  />
                <CustomRow >
                    <CustomCol label="文件名称" colStyle={{width: 802}}>
                        {detailData.fileSignUrl?<a style={{marginLeft: 6}} href={detailData.fileSignUrl} download><span style={{ paddingLeft:6 }}>{detailData.fileSignName}</span></a>:null}
                    </CustomCol>
                </CustomRow>
                <DetailTitle title="明细数据" />
                <Table columns={detailData.instructionType!=null&&detailData.instructionType===1?infoColumns:infoColumnsType1} dataSource={detailData.infoList} scroll={{x: 900}} />
                <DetailTitle title="回盘文件汇总数据" />
                <Table columns={counterofferColumns} dataSource={detailData.transferRecordCounterofferDataList} scroll={{x: 900}} />

                <DetailTitle title="退票列表" />
                <Table columns={refundFileColumns} dataSource={detailData.refundFileDataList} scroll={{x: 900}} />

                <Modal 
                    visible={!!counterofferInfoList} 
                    onCancel={() => setCounterofferInfoList(null)} 
                    title="回盘文件明细数据" 
                    width={1200}  
                    footer={<Button onClick={() => setCounterofferInfoList(null)}>关闭</Button>}
                >
                    <div style={{padding: 20}}>
                        <Table columns={counterofferInfoColumns} dataSource={counterofferInfoList} scroll={{x: 900}} />
                    </div>
                </Modal>
            </div>
        </ModalScrollContainer>
    </Modal>
}

export default TransferRecordDetail


// WEBPACK FOOTER //
// ./src/page/TransferRecordLog/detail.jsx